import type { InjectionKey, Ref } from 'vue'

import type { TIconName } from '../icon/types'
import type { TabSheetType } from './helpers'

export const tabsheetKey: InjectionKey<TabsheetContext> = Symbol('tabsheet')

export const tabsheetGroupKey: InjectionKey<Ref<number | undefined>> =
  Symbol('tabsheetgroup')

export interface TabsheetContext {
  id: string
  tabs: Ref<TabsheetTabDefinition[]>
  activeIndex: Ref<number>
  updateTab: (id: number, patch: Partial<TabsheetTabDefinition>) => void
  registerTab: (tab: TabsheetTabDefinition) => number
  unregisterTab: (index: number) => void
}

export interface TabsheetTabDefinition {
  title: string
  icon?: TIconName | undefined
  selected: boolean
}

export type TTabsheetType = (typeof TabSheetType)[keyof typeof TabSheetType]
